import React from 'react';

function Pawprint(props) {
  return (
    <svg width={25} height={24} viewBox="0 0 25 24" fill="#ffffff" {...props}>
      <g clipPath="url(#pawprint_prefix__clip0)">
        <path d="M17.036 12.72a5.815 5.815 0 00-4.917-2.691c-2 0-3.838 1.006-4.917 2.69L4.6 16.78a3.675 3.675 0 00-.576 2.25c.055.798.358 1.542.878 2.15a3.673 3.673 0 001.986 1.203 3.67 3.67 0 002.312-.22l.049-.022a7.263 7.263 0 015.787.022 3.676 3.676 0 002.31.22 3.672 3.672 0 001.987-1.202c.52-.608.824-1.352.879-2.15a3.676 3.676 0 00-.576-2.251l-2.6-4.06zM5.301 12.714c.774-.297 1.362-.92 1.655-1.756.28-.795.257-1.693-.064-2.528-.322-.834-.906-1.516-1.646-1.918-.778-.423-1.632-.492-2.404-.194-1.554.598-2.267 2.52-1.59 4.284.542 1.405 1.804 2.292 3.08 2.292.326 0 .653-.058.97-.18zM10.348 9.534c1.942 0 3.523-1.802 3.523-4.017 0-2.215-1.58-4.017-3.523-4.017S6.825 3.302 6.825 5.517c0 2.215 1.58 4.017 3.523 4.017zM16.432 10.52c.3.1.604.147.908.147 1.417 0 2.797-1.032 3.324-2.617.304-.913.284-1.878-.056-2.718-.355-.879-1.014-1.517-1.855-1.796-.84-.28-1.75-.163-2.56.328-.775.469-1.368 1.23-1.671 2.143-.64 1.925.217 3.95 1.91 4.513zM23.852 10.052c-1.34-.991-3.344-.562-4.468.956-1.122 1.52-.947 3.562.391 4.553a2.753 2.753 0 001.655.534c1.028 0 2.098-.525 2.813-1.49 1.122-1.52.947-3.562-.391-4.553z" />
      </g>
      <defs>
        <clipPath id="pawprint_prefix__clip0">
          <path d="M.996 0h23.986v24H.996z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Pawprint;
